import { Flex, FlexProps, Image, Link } from "@chakra-ui/core";
import React from "react";

import appStoreLogo from "../../assets/social/appstore.svg";
import playStoreLogo from "../../assets/social/playstore.svg";
import { useStoreUrls } from "../../services/app-download.service";

// A két store-badge, a CMS-ben beállított linkekkel. A badge-ek SVG-je
// 121×40 (App Store) és 135×40 (Google Play) arányú, ezért közös magasság.
function StoreBadges({
  height = "40px",
  isStacked = false,
  onStoreClick,
  ...props
}: FlexProps & {
  height?: string;
  isStacked?: boolean;
  onStoreClick?: () => void;
}): JSX.Element {
  const storeUrls = useStoreUrls();

  return (
    <Flex
      direction={isStacked ? "column" : "row"}
      alignItems={isStacked ? "flex-start" : "center"}
      {...props}
    >
      <Link
        href={storeUrls.ios}
        isExternal
        mr={isStacked ? 0 : "12px"}
        mb={isStacked ? "8px" : 0}
        onClick={onStoreClick}
        aria-label="Letöltés az App Store-ból"
      >
        <Image src={appStoreLogo} height={height} width="auto" />
      </Link>
      <Link
        href={storeUrls.android}
        isExternal
        onClick={onStoreClick}
        aria-label="Letöltés a Google Playről"
      >
        <Image src={playStoreLogo} height={height} width="auto" />
      </Link>
    </Flex>
  );
}

export default StoreBadges;
